/* eslint-disable */
import React, {useState} from 'react';
import 'contents/assets/scss/page/manage.scss';

import PopOffDuty from './_PopOffDuty';
import PopOnDutyTime from './_PopOnDutyTime';
import PopOnDutyRoutine from './_PopOnDutyRoutine';
import PopOnDutyLog from './_PopOnDutyLog';
import PopOnDutyChange from './_PopOnDutyChange';
import PopOnDutyChangeOk from './_PopOnDutyChangeOk';
function DutyLog() {
  const [modalOffDuty, setModalOffDuty] = useState(false);
  const [modalOnDutyTime, setModalOnDutyTime] = useState(false);
  const [modalOnDutyRoutine, setModalOnDutyRoutine] = useState(false);
  const [modalOnDutyLog, setModalOnDutyLog] = useState(false);
  const [modalOnDutyChange, setModalOnDutyChange] = useState(false);
  const [modalOnDutyChangeOk, setModalOnDutyChangeOk] = useState(false);
  return (
    <main className="com_container p_manage_dutyLog">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu9_11 active">당직 일지</h2>
          <div className="com_btn_wrap">
            <button
              onClick={() => {
                setModalOffDuty(true);
              }}
              className="com_btn gray s"
            >
              공휴일& 당직 쉬는날 지정하기
            </button>
            <button
              onClick={() => {
                setModalOnDutyTime(true);
              }}
              className="com_btn orange s"
            >
              당직 시간 관리
            </button>
            <button
              onClick={() => {
                setModalOnDutyRoutine(true);
              }}
              className="com_btn orange s btn_plus"
            >
              당직 루틴 등록
            </button>
          </div>
        </section>
        <section className="com_pg_container">
          <section className="box full">
            <div className="com_calendar_wrap">
              <div className="year ">
                <button className="btn btn_first"></button>
                <button className="btn btn_prev"></button>
                <button className="btn_txt">2023, 03, 31(수)</button>
                <button className="btn btn_next"></button>
                <button className="btn btn_last"></button>
              </div>
            </div>

            <section className="com_month_calendar">
              <ul className="month_header">
                <li className="date">월</li>
                <li className="date">화</li>
                <li className="date">수</li>
                <li className="date">목</li>
                <li className="date">금</li>
                <li className="date saturday">토</li>
                <li className="date holiday">일</li>
              </ul>
              <div className="month_schedule">
                <ul className="month_body">
                  <li className="date">
                    <span className="day_index">1</span>
                  </li>
                  <li className="date on">
                    <span className="day_index">2</span>
                    <div className="info">
                      <span className="name">
                        홍길동103
                        <button
                          onClick={() => {
                            setModalOnDutyChange(true);
                          }}
                          className="btn_edit_pen_circle"
                        ></button>
                      </span>
                      <span className="time">19 : 00 ~ 20 : 00</span>
                      <button
                        onClick={() => {
                          setModalOnDutyLog(true);
                        }}
                        className="com_btn gray"
                      >
                        당직 일지 보기
                      </button>
                    </div>
                  </li>
                  <li className="date">
                    <span className="day_index">3</span>
                    <div className="info">
                      <span className="name">
                        홍길동103
                        <button
                          onClick={() => {
                            setModalOnDutyChange(true);
                          }}
                          className="btn_edit_pen_circle"
                        ></button>
                      </span>
                      <span className="time">19 : 00 ~ 20 : 00</span>
                      <button
                        onClick={() => {
                          setModalOnDutyLog(true);
                        }}
                        className="com_btn gray"
                      >
                        당직일지 작성하기
                      </button>
                    </div>
                  </li>
                  <li className="date">
                    <span className="day_index">4</span>
                    <div className="info">
                      <span className="name">
                        홍길동103
                        <button
                          onClick={() => {
                            setModalOnDutyChange(true);
                          }}
                          className="btn_edit_pen_circle"
                        ></button>
                      </span>
                      <span className="time">19 : 00 ~ 20 : 00</span>
                      <span className="modify"></span>
                    </div>
                  </li>
                  <li className="date">
                    <span className="day_index">5</span>
                  </li>
                  <li className="date">
                    <span className="day_index">6</span>
                  </li>
                  <li className="date holiday">
                    <span className="day_index">7</span>
                  </li>
                </ul>
                <ul className="month_body">
                  <li className="date">
                    <span className="day_index">8</span>
                    <div className="info_none">당직 쉬는날</div>
                  </li>
                  <li className="date off">
                    <span className="day_index">9</span>
                  </li>
                  <li className="date off">
                    <span className="day_index">10</span>
                  </li>
                  <li className="date off">
                    <span className="day_index">11</span>
                  </li>
                  <li className="date">
                    <span className="day_index">12</span>
                  </li>
                  <li className="date">
                    <span className="day_index">13</span>
                  </li>
                  <li className="date holiday">
                    <span className="day_index">14</span>
                  </li>
                </ul>
                <ul className="month_body">
                  <li className="date">
                    <span className="day_index">15</span>
                    <div className="info">
                      <span className="name">
                        홍길동103 <button className="btn_edit_pen_circle"></button>
                      </span>
                      <span className="time">19 : 00 ~ 20 : 00</span>
                      <span className="modify">홀길동123 {`>`} 최영희456</span>
                      <button
                        onClick={() => {
                          setModalOnDutyChangeOk(true);
                        }}
                        className="com_btn gray"
                      >
                        당직자 변경 승인하기
                      </button>
                    </div>
                  </li>
                  <li className="date off">
                    <span className="day_index">16</span>
                  </li>
                  <li className="date off">
                    <span className="day_index">17</span>
                  </li>
                  <li className="date off">
                    <span className="day_index">18</span>
                  </li>
                  <li className="date">
                    <span className="day_index">19</span>
                  </li>
                  <li className="date">
                    <span className="day_index">20</span>
                  </li>
                  <li className="date holiday">
                    <span className="day_index">21</span>
                  </li>
                </ul>
                <ul className="month_body">
                  <li className="date">
                    <span className="day_index">22</span>
                  </li>
                  <li className="date off">
                    <span className="day_index">23</span>
                  </li>
                  <li className="date off">
                    <span className="day_index">24</span>
                  </li>
                  <li className="date off">
                    <span className="day_index">25</span>
                  </li>
                  <li className="date">
                    <span className="day_index">26</span>
                  </li>
                  <li className="date">
                    <span className="day_index">27</span>
                  </li>
                  <li className="date holiday">
                    <span className="day_index">28</span>
                  </li>
                </ul>
                <ul className="month_body">
                  <li className="date">
                    <span className="day_index">29</span>
                  </li>
                  <li className="date">
                    <span className="day_index">30</span>
                  </li>
                  <li className="date">
                    <span className="day_index">31</span>
                  </li>
                  <li className="date disable">
                    <span className="day_index">1</span>
                  </li>
                  <li className="date disable">
                    <span className="day_index">2</span>
                  </li>
                  <li className="date disable">
                    <span className="day_index">3</span>
                  </li>
                  <li className="date disable">
                    <span className="day_index">4</span>
                  </li>
                </ul>
              </div>
            </section>
          </section>
        </section>
      </div>
      <PopOffDuty open={modalOffDuty} close={() => setModalOffDuty(false)} />
      <PopOnDutyTime open={modalOnDutyTime} close={() => setModalOnDutyTime(false)} />
      <PopOnDutyRoutine open={modalOnDutyRoutine} close={() => setModalOnDutyRoutine(false)} />
      <PopOnDutyLog open={modalOnDutyLog} close={() => setModalOnDutyLog(false)} />
      <PopOnDutyChange open={modalOnDutyChange} close={() => setModalOnDutyChange(false)} />
      <PopOnDutyChangeOk open={modalOnDutyChangeOk} close={() => setModalOnDutyChangeOk(false)} />
    </main>
  );
}

export default DutyLog;
